import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'parcel-recipients' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
